/// <reference path="./Tag.ts" />
/// <reference path="./Iframe.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Youtube extends Iframe {

        /**
         * @param data
         */
        protected initialize(data: any) {
            data.set("html", "<iframe class=\"youtube\" src=\"https://www.youtube.com/embed/" + data.get("id") + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
            super.initialize(data);
        }
    }
}